import ComboRecentOrFavOrderItem from "./ComboRecentOrFavOrderItem"

// Full Menu List Componenet
export default class ComboFavoriteItemsCard extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            isMadeFavorite: true,
            faveCardDrawerIsClosed: true
        }

        this.favorite = "/images/2/icons/like-heart.png";
        this.unFavorite = "/images/2/icons/unfav-heart.png";

        this.toggleFaveStatus = this.toggleFaveStatus.bind(this);
        this.hideCardImagesAndTitle = this.hideCardImagesAndTitle.bind(this);
        this.showCardImagesAndTitle = this.showCardImagesAndTitle.bind(this);
        //this.sendIdForAccordionDropdown = this.sendIdForAccordionDropdown.bind(this)
    }
    componentDidMount() {      
        this.setState({isMadeFavorite : true})  
    }
    hideCardImagesAndTitle(){
        this.setState({faveCardDrawerIsClosed : true})
     }
 
     showCardImagesAndTitle(){
         this.setState({faveCardDrawerIsClosed : false})
      }
//    sendIdForAccordionDropdown(e){
//        this.props.sendAccordionId(this.props.favoriteOrder.id);
//    }
    toggleFaveStatus(e){ 
        this.setState({ isMadeFavorite: !this.state.isMadeFavorite })
        if(this.state.isMadeFavorite){
            var id = this.props.favoriteOrder.id;
            var localThis = this;
            //this.props.sendFavCardIdForRemoval(id); // TO BE REMOVED IN PROD
            
            $.ajax({
                url: "/api/sitecore/Menu/RemoveFavoriteOrder",
                type: "POST",
                data: {"favID": id}
            }).done(function (data) {
                if (data && data.status == "redirect") {
                  //window.location = data.url;
               } else {
                   //to remove the recent order from the list once its favorited
                   localThis.props.sendFavCardIdForRemoval(id);
                   this.setState({ isMadeFavorite: true })
                }   
            });
        }
        this.setState({ isMadeFavorite: true })
    }

    render() {
        return (
                <div id={this.props.favoriteOrder.id} className="fav-meal-container fixed-martop text-center w-100">
                                    <div className="iHop-Gotham fav-h4 h4">{this.props.favoriteOrder.name}</div>
                                    <button data-toggle="modal" data-target="" className="heart-button" onClick={this.toggleFaveStatus}>
                                        <img src={this.state.isMadeFavorite? this.favorite :  this.unFavorite} className="img-fluid like-heart" alt="favorite meals" />
                                    </button>
                                    <div className="pre-content">
                                        <div className="pre-wrapper">
                                            {this.state.faveCardDrawerIsClosed &&
                                            <div>
                                            <ul className="img-list-pre" role="list">
                                                {this.props.favoriteOrder.products.map(product => {
                                                     return (
                                                     <li className="img-list-item-pre">
                                                    <img src={product.productImageUrl ? product.productImageUrl : product.image} className="img-fluid" alt={product.name} />
                                                </li>
                                                );
                                                 })
                                                }                                                
                                            </ul>
                                            
                                            <p className="pre-text iHop-Gotham">
                                                  {this.props.favoriteOrder.products.map(product => {return product.name}).join(", ").trim()}
                                               </p>
                                               </div>
                                            }
                                       
                                        </div>
                                        <div className="exp-container text-left hide-sec">
                                        {
                                          this.props.favoriteOrder.products.map(menuData => {
                                              return (
                                                <ComboRecentOrFavOrderItem                                                    
                                                    title = {menuData.name}
                                                    img = {menuData.productImageUrl ? menuData.productImageUrl : menuData.image}
                                                    calories = {menuData.name}
                                                    description = {menuData.choices.map(choice => { return choice.name }).join(", ").trim() }
                                               />

                                            )
                                          })

                                    }
                                        </div>    
                                        <a href="javascript:;" className="closed-acc" role="link"><span onClick={this.showCardImagesAndTitle} id={this.props.favoriteOrder.id} className="see-full-txt">{this.props.favoriteData.SeeFullDetailsText}</span><span onClick={this.hideCardImagesAndTitle} id={this.props.favoriteOrder.id} className="close-txt hide-link">{this.props.favoriteData.CloseText}</span> <span id={this.props.favoriteOrder.id} className="down-arrow"></span></a>
                                        <a href="#" className="order-btn reorder-btn" role="button" data-value={this.props.favoriteOrder.id}><span className="order-txt" >{this.props.favoriteData.ReorderButtonText}</span></a>
                                    </div>
                          
          
                                </div>          
                        
        );
    }
}
